<template>
  <div
    id="pre-producto"
    v-bind:class="{'claseRandom1' : random == 1, 'claseRandom2' : random == 2}"
  >

    <v-alert
        class="alert-wishlist"
        height="50"
        transition="fade-transition"
        v-model="alertaWishlist"
      >
        <span>Se ha agregado a tu colección personal</span>
        <div class="centrar-right d-none d-md-flex">
          <router-link to="/wishlist" class="verde-oscuro">
            <span class="d-inline-block mr-3">VER MI COLECCIÓN PERSONAL</span>
            <v-icon>mdi-heart-outline</v-icon>
          </router-link>
        </div>
      </v-alert>

      <v-alert
        class="alert-NoSesion"
        height="50"
        transition="fade-transition"
        v-model="alertaNoSesion"
        color="#A37E60"
      >
        <span class="white--text">Inicia sesión para agregar productos a tu Colección Personal</span>
        <div class="centrar-right d-none d-md-flex">
          <router-link to="/login" class="white--text">
            <span>INICIA SESIÓN</span>
            <v-icon color="white" class="d-inline-block ml-3">mdi-account-outline</v-icon>
          </router-link>
        </div>
      </v-alert>
    <div id="producto" v-bind:class="{'claseRandom1' : random == 1, 'claseRandom2' : random == 2}">
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6">
            <v-breadcrumbs divider="|" :items="items" class="py-0 pl-3"></v-breadcrumbs>
          </v-col>
          <v-col cols="12" sm="6" class="text-right d-none d-sm-block compartir-producto">
            <span
              class="modernist-bold d-inline-block mr-2"
              style="color: #03241D; font-size:12px; vertical-align: middle; letter-spacing: 2px;"
            >COMPARTIR</span>
            
            <Facebook :url="'https://chlorophilia.com/tienda/'+prod.Url">
              <v-icon color="#03241D" class="mr-2">mdi-facebook</v-icon>
            </Facebook>
            <Twitter :url="'https://chlorophilia.com/tienda/'+prod.Url" :title="prod.NombreComun">
              <v-icon color="#03241D" class="mr-2">mdi-twitter</v-icon>
            </Twitter>
            <Pinterest :url="'https://chlorophilia.com/tienda/'+prod.Url">
              <v-icon color="#03241D" class="margin-right-manual">mdi-pinterest</v-icon>
            </Pinterest>
          </v-col>
        </v-row>
      </v-container>

      <v-alert class="alert-cart" height="50" transition="fade-transition" v-model="alertaCart">
        <span>Se ha añadido un producto a tu cesta</span>
        <div class="centrar-right d-none d-md-flex">
          <router-link to="/cart" class="white--text">
            <span>MI CESTA</span>
            <img src="../assets/img/iconos/cesta.svg" alt />
          </router-link>
        </div>
      </v-alert>

      

      

      <v-container fluid producto-datos-container intro-container class="py-0">
        <div class="producto-ventana">
          <v-row justify="center">
            <v-col cols="12" md="6" class="py-0 d-block d-sm-none d-md-block" >
                <div>
                  <v-img
                    :src="'https://strapi.actstudio.xyz/'+imagenes[0].url"
                    width="100%"
                    height="calc(100vh - 220px)"
                    :contain="true"
                  ></v-img>
                </div>
              <transition name="fade-transition">
                <!-- <v-carousel
                  v-model="carousel"
                  class="producto-carousel"
                  height="calc(100vh - 220px)"
                  :hide-delimiter-background="true"
                  :show-arrows="false"
                  v-if="show_carousel"
                  :hide-delimiters="true"
                  
                >
                  <v-carousel-item v-for="(imagen,i) in imagenes" :key="i">
                    <v-img
                      :src="'https://strapi.actstudio.xyz/'+imagen.url"
                      width="100%"
                      height="100%"
                      :contain="true"
                    ></v-img>
                  </v-carousel-item>
                  <v-carousel-item>
                    
                  </v-carousel-item>
                </v-carousel> -->
              </transition>
              <div v-if="false" style="max-width: 535px; margin-left: auto; margin-right: 5%;">
                <v-row>
                  <v-col class="text-left">
                    <span style="color: #03241D;">
                      Descargar
                      <v-icon color="#03241D">mdi-download</v-icon>
                    </span>
                  </v-col>
                  <v-col class="text-right">
                    <span style="color: #03241D">
                      Envios y devoluciones
                      <v-icon color="#03241D">mdi-information-outline</v-icon>
                    </span>
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <!-- *****************/columna oculta de md para abajo********* -->
            <v-col cols="12" md="6" class="py-0 d-none d-sm-block d-md-none">
              <transition name="fade-transition">
                <v-carousel
                  v-model="carousel"
                  class="producto-carousel"
                  height="calc(100vh - 524px)"
                  :hide-delimiter-background="true"
                  :hide-delimiters="true"
                  :show-arrows="false"
                  v-if="show_carousel"
                >
                  <v-carousel-item v-for="(imagen,i) in imagenes" :key="i">
                    <v-img
                      :src="'https://strapi.actstudio.xyz/'+imagen.url"
                      width="100%"
                      height="100%"
                      :contain="true"
                    ></v-img>
                  </v-carousel-item>
                </v-carousel>
              </transition>
              <div v-if="false" style="max-width: 535px; margin-left: auto; margin-right: 5%;">
                <v-row>
                  <v-col class="text-left">
                    <span style="color: #03241D;">
                      Descargar
                      <v-icon color="#03241D">mdi-download</v-icon>
                    </span>
                  </v-col>
                  <v-col class="text-right">
                    <span style="color: #03241D">
                      Envios y devoluciones
                      <v-icon color="#03241D">mdi-information-outline</v-icon>
                    </span>
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <!-- *****************/columna oculta de md para abajo********* -->

            <v-col cols="12" md="6">
              <div>
                <div class="text-center text-md-left">
                  <span class="encabezado mr-4" style="vertical-align: middle;">{{prod.NombreComun}}</span>

                  <template v-if="tamano == 0">
                    <v-btn
                      fab
                      x-small
                      elevation="0"
                      color="#E2D4CA"
                      class="no-effect"
                      @click="agregarWishlist(prod.id)"
                      :ripple="false"
                      height="35px"
                      width="35px"
                      style="vertical-align: middle;"
                    >
                      <v-icon small size="18">mdi-heart-outline</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                      <v-btn
                      fab
                      x-small
                      elevation="0"
                      color="transparent"
                      class="no-effect d-none d-md-inline"
                      @click="agregarWishlist(prod.id)"
                      :ripple="false"
                      height="35px"
                      width="35px"
                      style="vertical-align: middle;"
                    >
                      <v-icon small size="18" color="transparent">mdi-heart-outline</v-icon>
                    </v-btn>
                  </template>
                  <span
                    class="modernist-bold d-block gris uppercase"
                    style="letter-spacing: 2px;"
                  >{{prod.NombreCientifico}}</span>

                  <div class="mt-6 mb-3 mt-md-3 mb-md-2 text-left d-none d-md-block" style="max-width: 400px;">
                    
                    <span class="texto-corrido prod-description mx-auto-xs mx-sm-auto mx-md-0" style="font-size: 12px;">{{prod.Descripcion}}</span>
                  </div>

                  <div class="mt-6 mb-3 mt-md-3 mb-md-2 text-left d-md-none mx-auto" style="max-width: 300px;">
                    <!-- <span
                      class="subtitulo text-left d-block mb-3"
                      style="text-transform:uppercase"
                    >TAMBIÉN CONOCIDA COMO: {{prod.OtrosNombresComunes}}</span> -->

                    <span v-if="!show_description" class="d-block text-center" @click="show_description = true;" style="text-decoration: underline; color:#979797;">Ver descripción de la especie</span>
                    <span v-if="show_description" class="texto-corrido prod-description mx-auto-xs mx-sm-auto mx-md-0 d-block" style="font-size: 12px;">{{prod.Descripcion}}</span>
                    <div class="text-center mt-4" v-if="show_description">
                      <span class="d-block" style="text-decoration: underline; color:#979797;" @click="show_description = false;">Ocultar descripción de la especie</span>
                    </div>
                  </div>

                  <template v-for="(size,i) in producto.precios">
                    <div class="producto-precios animated fadeIn" v-show="tamano == i" :key="i">
                      <span class="encabezado">${{size.value.precio}}</span>
                      <span class="encabezado">${{size.value.precio}}</span>
                      <span class="subtitulo">DESCUENTO</span>
                    </div>
                  </template>

                  <div class="producto-tamanos" style="position:relative;">
                    <template v-if="prod.ActivoChico">
                      <div>
                        <span
                          class="subtitulo d-inline-block"
                          @click="tamano = 'c'; show_description = false;"
                          style="cursor: pointer;"
                          v-bind:class="{'activo' : tamano == 'c'}"
                        >CH</span>
                      </div>
                    </template>

                    <template v-if="prod.ActivoMediano">
                      <div>
                        <span class="linea" v-if="prod.ActivoChico">|</span>
                        <span
                          class="subtitulo d-inline-block"
                          @click="tamano = 'm'; show_description = false;"
                          style="cursor: pointer;"
                          v-bind:class="{'activo' : tamano == 'm'}"
                        >M</span>
                      </div>
                    </template>

                    <template v-if="prod.ActivoGrande">
                      <div>
                        <span class="linea" v-if="prod.ActivoChico || prod.ActivoMediano">|</span>
                        <span
                          class="subtitulo d-inline-block"
                          @click="tamano = 'g'; show_description = false;"
                          style="cursor: pointer;"
                          v-bind:class="{'activo' : tamano == 'g'}"
                        >G</span>
                      </div>
                    </template>

                    <div style="border-left: none; padding: 0px;">
                      <span
                        style="padding: 0px; width: auto; color:#03241D; opacity: 1; background-color: transparent;"
                        v-if="tamano == 'c'"
                        class="d-block mx-auto mt-3"
                      >De 4.5" a 7.5" de diámetro</span>
                      <span
                        style="padding: 0px; width: auto; color:#03241D; opacity: 1; background-color: transparent;"
                        v-if="tamano == 'm'"
                        class="d-block mx-auto mt-3"
                      >De 9.5" a 12 " de diámetro</span>
                      <span
                        style="padding: 0px; width: auto; color:#03241D; opacity: 1; background-color: transparent;"
                        class="d-block mx-auto mt-3"
                        v-if="tamano == 'g'"
                      >De 13" a 16" de diámetro</span>
                    </div>
                  </div>
                </div>

                

                

                <div class="producto-macetas" v-if="macetas.length > 0">
                  <span class="subtitulo">ELIGE MACETA</span>
                  <hr />
                  <div class="subtitulo-producto" style=" vertical-align: middle; position: relative;">
                    <template v-for="(maceta,m) in macetas">

                      <template v-if="ciudad_seleccionada == 'Querétaro'">
                        
                        <template v-if="maceta.ActivoQueretaro">
                        
                        

                          <!-- v-if="maceta_seleccionada == 0 || maceta_seleccionada == maceta.id" -->
                          <div
                            class="d-inline-block mr-3 maceta-forma"
                            v-bind:key="m"
                            v-bind:class="{'seleccionada':maceta_seleccionada == maceta.id}"
                            style="vertical-align:middle;"
                          >
                            <div class="d-inline-block text-center maceta-seleccion" style="cursor: pointer">
                              <v-img
                                :src="'https://strapi.actstudio.xyz/'+maceta.DisenoMaceta.url"
                                :key="m+'maceta'"
                                width="40px"
                                height="40px"
                                contain
                                position="center center"
                                class="d-inline-block mx-auto"
                                @click="seleccionarMaceta(maceta);"
                                @mouseover="maceta_over = maceta.id; imagenes = maceta.Imagen; refresh_carousel();"
                                @mouseout="maceta_over = 0"
                                style="vertical-align: middle;"
                              ></v-img>
                              <span
                                v-if="maceta_seleccionada == maceta.id"
                                class="d-block mx-auto mt-2"
                                v-bind:class="{'subrayado' : maceta_seleccionada == maceta.id}"
                                style="vertical-align: middle;"
                              >{{maceta.Nombre}}</span>
                              <span
                                v-if="maceta_over == maceta.id && maceta_seleccionada != maceta.id"
                                class="d-block mx-auto mt-2"
                                style="vertical-align: middle;"
                              >{{maceta.Nombre}}</span>
                            </div>
                            <!-- <span
                              v-if="maceta_seleccionada == maceta.id"
                              style="position: absolute; right: 0px; top: 50%; transform: translateY(-50%);"
                              @click="maceta_seleccionada = 0;"
                            >Cambiar</span>-->
                          </div>
                        </template>


                      </template>
                      <template v-else>
                        <template v-if="maceta.Activo">
                        
                        

                          <!-- v-if="maceta_seleccionada == 0 || maceta_seleccionada == maceta.id" -->
                          <div
                            class="d-inline-block mr-3 maceta-forma"
                            v-bind:key="m"
                            v-bind:class="{'seleccionada':maceta_seleccionada == maceta.id}"
                            style="vertical-align:middle;"
                          >
                            <div class="d-inline-block text-center maceta-seleccion" style="cursor: pointer">
                              <v-img
                                :src="'https://strapi.actstudio.xyz/'+maceta.DisenoMaceta.url"
                                :key="m+'maceta'"
                                width="40px"
                                height="40px"
                                contain
                                position="center center"
                                class="d-inline-block mx-auto"
                                @click="seleccionarMaceta(maceta);"
                                @mouseover="maceta_over = maceta.id; imagenes = maceta.Imagen; refresh_carousel();"
                                @mouseout="maceta_over = 0"
                                style="vertical-align: middle;"
                              ></v-img>
                              <span
                                v-if="maceta_seleccionada == maceta.id"
                                class="d-block mx-auto mt-2"
                                v-bind:class="{'subrayado' : maceta_seleccionada == maceta.id}"
                                style="vertical-align: middle;"
                              >{{maceta.Nombre}}</span>
                              <span
                                v-if="maceta_over == maceta.id && maceta_seleccionada != maceta.id"
                                class="d-block mx-auto mt-2"
                                style="vertical-align: middle;"
                              >{{maceta.Nombre}}</span>
                            </div>
                            <!-- <span
                              v-if="maceta_seleccionada == maceta.id"
                              style="position: absolute; right: 0px; top: 50%; transform: translateY(-50%);"
                              @click="maceta_seleccionada = 0;"
                            >Cambiar</span>-->
                          </div>
                        </template>
                      </template>

                    </template>
                    <!-- <div class="d-block">
                      <template v-for="(maceta,m) in macetas">
                        <span
                          class="modernist-bold uppercase mt-2 d-block"
                          style="color: #979797; font-size: 12px; letter-spacing: 1; letter-spacing: 1px;"
                          v-if="maceta_over == maceta.id && maceta_seleccionada == 0"
                          :key="m"
                        >{{maceta.Nombre}}</span>
                      </template>
                    </div>-->
                  </div>
                </div>

                <div class="producto-bases" v-if="maceta_seleccionada != 0">
                  <template v-if="maceta_seleccionada_info.Base.length > 0">
                    <span class="subtitulo">ELIGE BASE</span>
                    <hr />
                  </template>

                  <div style="max-width: 400px; position:relative">
                    <template v-if="maceta_seleccionada_info != null">
                      <template v-for="(base,b) in maceta_seleccionada_info.Base">
                        
                        <template v-if="ciudad_seleccionada == 'Querétaro'">
                          <template v-if="base.ActivoQueretaro">
                          
                            <div class="d-inline-block mr-3" v-bind:key="b">
                              <span
                                style="cursor:pointer;"
                                @click="base_seleccionada = base.id; base_seleccionada_info = base; imagenes = base.Imagen; refresh_carousel();"
                                v-bind:class="{'seleccionada':base_seleccionada == base.id}"
                              >{{base.Nombre}}</span>
                            </div>

                            <div
                              class="d-inline-block ml-3"
                              v-if="base_seleccionada == base.id"
                              v-bind:key="b"
                            >
                              <span
                                class="modernist-bold d-block gris uppercase"
                                style="font-size: 12px; position: absolute; right: 0px; top: 50%; transform: translateY(-50%); letter-spacing: 2px; cursor: pointer;"
                                @click="base_seleccionada = 0;"
                              >eliminar</span>
                            </div>
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="base.Activo">
                          
                            <div class="d-inline-block mr-3" v-bind:key="b">
                              <span
                                style="cursor:pointer;"
                                @click="base_seleccionada = base.id; base_seleccionada_info = base; imagenes = base.Imagen; refresh_carousel();"
                                v-bind:class="{'seleccionada':base_seleccionada == base.id}"
                              >{{base.Nombre}}</span>
                            </div>

                            <div
                              class="d-inline-block ml-3"
                              v-if="base_seleccionada == base.id"
                              v-bind:key="b"
                            >
                              <span
                                class="modernist-bold d-block gris uppercase"
                                style="font-size: 12px; position: absolute; right: 0px; top: 50%; transform: translateY(-50%); letter-spacing: 2px; cursor: pointer;"
                                @click="base_seleccionada = 0;"
                              >eliminar</span>
                            </div>
                          </template>
                        </template>
                        
                        




                      </template>
                    </template>
                  </div>
                </div>

                <div class="producto-botones-div d-block d-md-flex">
                  <div class="d-block d-md-inline-block mr-3 text-center text-md-left mt-6 mt-md-0">
                    <!-- <v-btn @click="borrar_carrito">Borrar</v-btn> -->
                    <template v-if="maceta_seleccionada == 0">
                      <span class="modernist-bold" style="letter-spacing: 1px;">DESDE</span>
                      <br />
                    </template>

                    <template v-if="base_seleccionada != 0">
                      <!-- <span class="modernist-bold" style="letter-spacing: 1px;">DESDE</span>
                      <br />-->
                      <span
                        class="modernist-bold"
                        style="font-size: 22px; letter-spacing:1px;"
                      >${{base_seleccionada_info.Precio}}.00</span>
                    </template>
                    <template v-else-if="maceta_seleccionada != 0">
                      <span
                        class="modernist-bold"
                        style="font-size: 22px; letter-spacing:1px;"
                      >${{maceta_seleccionada_info.Precio}}.00</span>
                    </template>
                    <template v-else>
                      <template v-if="tamano == 0">
                        <template v-if="prod.ActivoChico">
                          <!-- <span class="modernist-bold" style="letter-spacing: 1px;">DESDE</span>
                          <br />-->
                          <span
                            class="modernist-bold"
                            style="font-size: 22px; letter-spacing:1px;"
                          >${{prod.PrecioChico}}.00</span>
                        </template>

                        <template v-else-if="prod.ActivoMediano">
                          <!-- <span class="modernist-bold" style="letter-spacing: 1px;">DESDE</span>
                          <br />-->
                          <span
                            class="modernist-bold"
                            style="font-size: 22px; letter-spacing:1px;"
                          >${{prod.PrecioMediano}}.00</span>
                        </template>

                        <template v-else-if="prod.ActivoGrande">
                          <!-- <span class="modernist-bold" style="letter-spacing: 1px;">DESDE</span>
                          <br />-->
                          <span
                            class="modernist-bold"
                            style="font-size: 22px; letter-spacing:1px;"
                          >${{prod.PrecioGrande}}.00</span>
                        </template>
                      </template>
                      <template v-if="tamano == 'c'">
                        <span
                          class="modernist-bold"
                          style="font-size: 22px; letter-spacing:1px;"
                        >${{prod.PrecioChico}}.00</span>
                      </template>
                      <template v-if="tamano == 'm'">
                        <span
                          class="modernist-bold"
                          style="font-size: 22px; letter-spacing:1px;"
                        >${{prod.PrecioMediano}}.00</span>
                      </template>

                      <template v-if="tamano == 'g'">
                        <span
                          class="modernist-bold"
                          style="font-size: 22px; letter-spacing:1px;"
                        >${{prod.PrecioGrande}}.00</span>
                      </template>
                    </template>

                    <!-- <span class="modernist-bold" style="letter-spacing: 1px;">DESDE</span>
                    <br />
                    <span class="modernist-bold" style="font-size: 20px; letter-spacing:1px;">$520.00</span>-->
                  </div>
                  <template v-if="maceta_seleccionada != 0">
                    <br class="d-md-none" />
                    <div class="px-1 py-3 mx-md-3 mr-3 d-inline-block mt-5 mt-md-0" style="border: 1px solid #D8D8D8;">
                      <v-btn
                        tile
                        icon
                        :ripple="false"
                        x-small
                        @click="cantidad--; actualizarCarrito();"
                        :disabled="cantidad <= 1"
                      >
                        <v-icon size="14">mdi-minus</v-icon>
                      </v-btn>
                      <span class="d-inline-block px-3 text-center" style="width: 45px;">{{cantidad}}</span>
                      <v-btn
                        tile
                        icon
                        :ripple="false"
                        x-small
                        @click="cantidad++; actualizarCarrito();"
                        :disabled="cantidad > 19"
                      >
                        <v-icon size="14">mdi-plus</v-icon>
                      </v-btn>
                    </div>
                    <!-- <v-text-field
                      hide-details
                      solo
                      v-model="cantidad"
                      flat
                      :full-width="false"
                      background-color="white #064434"
                      :rounded="false"
                      :dense="true"
                      :shaped="true"
                      class="cantidad-centro mr-3"
                      type="number"
                      min="1"
                      width="100%"
                    ></v-text-field> -->
                    <v-btn
                      tile
                      elevation="0"
                      :disabled="add_cart_enabled"
                      @click="add_Cart()"
                      color="#064434"
                      dark
                    >
                      <span class="subtitulo">AÑADIR A MI CESTA</span>
                    </v-btn>
                  </template>
                  <!-- <button class="boton-ver-producto" @click="add_Cart()">AÑADIR A MI CESTA</button> -->
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>

      <!-- cuidados escenciales -->
      <v-container mt-6>
        <v-row class="mb-3 text-center text-md-left" justify="center">
          <v-col cols="12" class="text-center">
            <span class="encabezado">Acerca de la especie y accesorios</span>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="12" class="text-center">
            <div class="my-3">
              <span
                class="subtitulo d-block mb-12"
                style="text-transform:uppercase"
              >ESTA ESPECIE TAMBIÉN ES CONOCIDA COMO: <br> {{prod.OtrosNombresComunes}}</span>
            </div>
            <div class="producto-ideal-para my-6">
              <span class="subtitulo">IDEAL PARA</span>
              <hr class="mx-auto my-6" style="max-width: 500px;" />
              <div>
                <span class="producto-ideal-para-texts d-inline-block" v-if="prod.IdealPiso">Piso</span>

                <span
                  class="producto-ideal-para-texts d-inline-block"
                  v-if="prod.IdealElevado"
                >Elevado</span>

                <span
                  class="producto-ideal-para-texts d-inline-block mr-1"
                  v-if="prod.IdealInterior"
                >,</span>

                <span
                  class="producto-ideal-para-texts d-inline-block"
                  v-if="prod.IdealInterior"
                >Interior</span>

                <span
                  class="producto-ideal-para-texts d-inline-block mr-1"
                  v-if="prod.IdealExteriorCubierto"
                >,</span>

                <span
                  class="producto-ideal-para-texts d-inline-block"
                  v-if="prod.IdealExteriorCubierto"
                >Exterior Cubierto</span>

                <span
                  class="producto-ideal-para-texts d-inline-block mr-1"
                  v-if="prod.IdealExteriorAbierto"
                >,</span>

                <span
                  class="producto-ideal-para-texts d-inline-block"
                  v-if="prod.IdealExteriorAbierto"
                >Exterior Abierto</span>

                <span class="producto-ideal-para-texts d-inline-block mr-1" v-if="prod.IdealSola">,</span>

                <span class="producto-ideal-para-texts d-inline-block" v-if="prod.IdealSola">Sola</span>

                <span
                  class="producto-ideal-para-texts d-inline-block mr-1"
                  v-if="prod.IdealAgrupada"
                >,</span>

                <span
                  class="producto-ideal-para-texts d-inline-block"
                  v-if="prod.IdealAgrupada"
                >Agrupada</span>

                <span
                  class="producto-ideal-para-texts d-inline-block mr-1"
                  v-if="prod.IdealReducido"
                >,</span>

                <span
                  class="producto-ideal-para-texts d-inline-block"
                  v-if="prod.IdealReducido"
                >Espacios Reducidos</span>

                <span
                  class="producto-ideal-para-texts d-inline-block mr-1"
                  v-if="prod.IdealAmplio"
                >,</span>

                <span
                  class="producto-ideal-para-texts d-inline-block"
                  v-if="prod.IdealAmplio"
                >Espacios Amplios</span>
              </div>
            </div>
            
          </v-col>
          <v-col cols="12" md="6" class="px-lg-3">
            <div class="producto-cuidados-escenciales-bloque-rosa">
              <v-row>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  style="background-color: #FDFBF5;"
                  class="py-12 py-sm-0 px-0"
                >
                  <div class="text-center" style="position: relative;">
                    <img src="../assets/img/riego.png" alt />
                    <span class="subtitulo">RIEGO</span>
                    <span
                      class="texto-corrido"
                      v-if="prod.RiegoEnum == 'Abundante'"
                    >{{prod.RiegoEnum}}</span>
                    <span
                      class="texto-corrido"
                      v-if="prod.RiegoEnum == 'Moderado'"
                    >{{prod.RiegoEnum}}</span>
                    <span
                      class="texto-corrido"
                      v-if="prod.RiegoEnum == 'ModeradoBajo'"
                    >Moderado Bajo</span>

                    <v-avatar
                      color="#D8D8D8"
                      size="18"
                      class="my-3"
                      style="cursor: pointer;"
                      @mouseover="caracteristica_abierta = 1;"
                      v-if="caracteristica_abierta != 1"
                    >
                      <v-icon size="16">mdi-plus</v-icon>
                    </v-avatar>

                    <v-avatar
                      color="#D8D8D8"
                      size="18"
                      class="my-3"
                      style="cursor: pointer;"
                      @mouseover="caracteristica_abierta = 0;"
                      v-if="caracteristica_abierta == 1"
                    >
                      <v-icon size="16">mdi-minus</v-icon>
                    </v-avatar>

                    <transition name="fade-transition">
                      <div
                        class="mx-auto d-block producto-caracteristica-padding"
                        style="background-color: #EAE1D0; position: absolute; width: 100%; z-index: 10; cursor: pointer;"
                        v-if="caracteristica_abierta == 1"
                      >{{prod.Riego}}</div>
                    </transition>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  class="py-12 py-sm-0 px-0 producto-caracteristica-columna"
                >
                  <div class="text-center" style="position: relative;">
                    <img src="../assets/img/exposicion.png" alt />
                    <span class="subtitulo">
                      EXPOSICIÓN
                      <br class="hidden-lg-and-up" />AL SOL
                    </span>
                    <span
                      class="texto-corrido"
                      v-if="prod.ExposicionEnum == 'DirectaIndirectaAlta'"
                    >Directa o Indirecta Alta</span>
                    <span
                      class="texto-corrido"
                      v-if="prod.ExposicionEnum == 'IndirectaMedia'"
                    >Indirecta Media</span>
                    <span
                      class="texto-corrido"
                      v-if="prod.ExposicionEnum == 'IndirectaBaja'"
                    >Indirecta Baja</span>

                    <v-avatar
                      color="#D8D8D8"
                      size="18"
                      class="my-3"
                      style="cursor: pointer"
                      @mouseover="caracteristica_abierta = 2;"
                      v-if="caracteristica_abierta != 2"
                    >
                      <v-icon size="16">mdi-plus</v-icon>
                    </v-avatar>

                    <v-avatar
                      color="#D8D8D8"
                      size="18"
                      class="my-3"
                      style="cursor: pointer"
                      @mouseover="caracteristica_abierta = 0;"
                      v-if="caracteristica_abierta == 2"
                    >
                      <v-icon size="16">mdi-minus</v-icon>
                    </v-avatar>

                    <transition name="fade-transition">
                      <div
                        class="mx-auto d-block producto-caracteristica-padding"
                        style="background-color: #EAE1D0;  position: absolute; width: 100%; z-index: 10;"
                        v-if="caracteristica_abierta == 2"
                      >{{prod.Exposicion}}</div>
                    </transition>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  style="background-color: #FDFBF5;"
                  class="py-12 py-sm-0 px-0"
                >
                  <div class="text-center" style="position: relative;">
                    <img src="../assets/img/floracion.png" alt />
                    <span class="subtitulo">FLORACIÓN</span>
                    <span class="texto-corrido">{{prod.FloracionEnum}}</span>

                    <v-avatar
                      color="#D8D8D8"
                      size="18"
                      class="my-3"
                      style="cursor: pointer"
                      @mouseover="caracteristica_abierta = 3;"
                      v-if="caracteristica_abierta != 3"
                    >
                      <v-icon size="16">mdi-plus</v-icon>
                    </v-avatar>

                    <v-avatar
                      color="#D8D8D8"
                      size="18"
                      class="my-3"
                      style="cursor: pointer"
                      @mouseover="caracteristica_abierta = 0;"
                      v-if="caracteristica_abierta == 3"
                    >
                      <v-icon size="16">mdi-minus</v-icon>
                    </v-avatar>
                    <transition name="fade-transition">
                      <div
                        class="mx-auto d-block producto-caracteristica-padding"
                        style="background-color: #EAE1D0; position: absolute; width: 100%; z-index: 10;"
                        v-if="caracteristica_abierta == 3"
                      >{{prod.Floracion}}</div>
                    </transition>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-container>
        <div class="producto-diseno">
          <!-- <v-row>
            <v-col cols="12">
              <span class="encabezado subrayado">Diseño</span>
            </v-col>
          </v-row>-->
          <v-row v-if="maceta_seleccionada > 0">
            <v-col cols="12" sm="6">
              <!-- {{maceta_seleccionada_info.Medidas}} -->

              <v-carousel
                v-if="prod.DisenoMacetas.length > 0"
                :hide-delimiter-background="true"
                :show-arrows="false"
                :hide-delimiters="true"
                height="auto"
              >
                <v-carousel-item v-for="(img,i) in maceta_seleccionada_info.Medidas" :key="i">
                  <v-img
                    :src="'https://strapi.actstudio.xyz'+img.url"
                    width="100%"
                    height="100%"
                    position="bottom"
                    :contain="true"
                  ></v-img>
                </v-carousel-item>
              </v-carousel>
              <span
                style="font-size: 12px;"
                class="d-block mt-3 text-center"
              >{{maceta_seleccionada_info.Dimensiones}}</span>
              <!-- <div class="producto-diseno-tamanos-img">
                <template v-for="(size,i) in producto.Tamano">
                  <img
                    class="animated fadeIn"
                    :src="'http://192.168.15.100:1337'+size.diseno.url"
                    :key="i"
                    v-if="diseno_tamano == i"
                  />
                </template>
              </div>
              <div class="producto-tamanos mt-2">
                <template v-for="(size,i) in producto.Tamano">
                  <template v-if="diseno_tamano == i">
                    <v-btn
                      fab
                      small
                      elevation="0"
                      color="#e2d4ca"
                      :key="i"
                      @click="diseno_tamano = i"
                      class="mx-1 no-effect"
                      :ripple="false"
                    >{{size.name}}</v-btn>
                  </template>
                  <template v-else>
                    <v-btn
                      fab
                      small
                      elevation="0"
                      color="#e2d4ca"
                      :key="i"
                      @click="diseno_tamano = i"
                      class="mx-1 no-effect"
                      :ripple="false"
                      style="opacity: .3"
                    >{{size.name}}</v-btn>
                  </template>
                </template>
              </div>-->
            </v-col>
            <v-col cols="12" sm="6">
              <v-carousel
                v-if="prod.MoodMacetas.length > 0"
                :hide-delimiter-background="true"
                :hide-delimiters="true"
                :show-arrows="false"
                height="auto"
              >
                <v-carousel-item v-for="(img,i) in maceta_seleccionada_info.Moodboard" :key="i">
                  <v-img
                    :src="'https://strapi.actstudio.xyz'+img.url"
                    width="100%"
                    height="100%"
                    position="bottom"
                    :contain="true"
                  ></v-img>
                </v-carousel-item>
              </v-carousel>
              <!-- <div class="producto-diseno-tamanos-img">
                <img
                  src="../assets/img/identidad/chlorophilia-identidad-13.jpg"
                  style="width: 100%; height: 100%"
                />
              </div>
              <div class="text-center pt-3">
                <span class="texto-corrido">Maeta de barra con tripié hecha de herreria</span>
              </div>-->
            </v-col>
          </v-row>
        </div>
        <v-row class="d-sm-none">
          <v-col cols="12" class="text-center">
            <span
              class="modernist-bold d-inline-block mr-2"
              style="color: #03241D; font-size:12px; vertical-align: middle; letter-spacing: 2px;"
            >COMPARTIR</span>
          </v-col>
          <v-col cols="12" sm="6" class="text-center compartir-producto">
            <Facebook :url="'https://chlorophilia.com/tienda/'+prod.Url">
              <v-icon color="#03241D" class="mr-2">mdi-facebook</v-icon>
            </Facebook>
            <Twitter :url="'https://chlorophilia.com/tienda/'+prod.Url" :title="prod.NombreComun">
              <v-icon color="#03241D" class="mr-2">mdi-twitter</v-icon>
            </Twitter>
            <Pinterest :url="'https://chlorophilia.com/tienda/'+prod.Url">
              <v-icon color="#03241D" class="margin-right-manual">mdi-pinterest</v-icon>
            </Pinterest>
          </v-col>
        </v-row>
      </v-container>

      <div class="bg-verde-claro my-30" style="height: 40px">
        <v-container fill-height>
          <v-row>
            <span class="titulo d-block pl-7" style="font-size: 12px;">TAMBIÉN TE PUEDEN INTERESAR</span>
          </v-row>
        </v-container>
      </div>

      <v-container pb-30>
        <v-row class="px-4">
          <v-col
            cols="12"
            sm="3"
            class="producto-relacionado"
            v-for="(relacionado,r) in prod.productos"
            :key="r"
          >
            <router-link :to="'/tienda/'+relacionado.url">
              <div class="producto-relacionado-img">
                <v-img
                  :src="'https://strapi.actstudio.xyz'+relacionado.ImagenPrincipal.url"
                  :aspect-ratio="1"
                ></v-img>
                <!-- <img :src="'https://strapi.actstudio.xyz'+relacionado.ImagenPrincipal.url" /> -->
                <div class="producto-relacionado-hover">
                  <router-link :to="'/tienda/'+relacionado.url" class>VER PRODUCTO</router-link>
                  <span class="boton-favorito" style="cursor: pointer;">
                    <img src="../assets/img/iconos/wishlist_n.svg" alt />
                  </span>
                </div>
              </div>
            </router-link>
            <div style="margin-top: 10px;">
              <span
                class="modernist-bold"
                style="font-size: 16px; letter-spacing: 1px;"
              >{{relacionado.NombreComun}}</span>
              <span
                class="modernist-bold d-block gris uppercase"
                style="letter-spacing: 2px;"
              >{{relacionado.NombreCientifico}}</span>
              <!-- <span
                class="modernist-bold"
                style="font-size: 12px; letter-spacing: 1px;"
              >{{relacionado.NombreCientifico}}</span>-->
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!-- <v-btn color="success" @click="login()">Login</v-btn> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueSession from "vue-session";

Vue.use(VueSession, { persist: true });
 
import { Facebook, Twitter, Pinterest } from 'vue-socialmedia-share';


export default {
  components: {
    Facebook,
    Twitter,
    Pinterest
  },
  data: function() {
    return {
      items: [
        {
          text: "Inicio",
          disabled: false,
          to: "/"
        },
        {
          text: "Store",
          disabled: false,
          to: "/Tienda"
        },
        {
          text: "",
          disabled: true,
          to: "breadcrumbs_link_2"
        }
      ],
      ciudad_seleccionada: null,
      carousel: 0,
      tamano: 0,
      diseno_tamano: 0,
      alertaCart: false,
      alertaWishlist: false,
      alertaNoSesion: false,
      producto: [],
      prod: [],
      cantidad: 1,
      macetas: [],
      maceta_seleccionada: 0,
      maceta_over: 0,
      imagenes: [],
      show_carousel: true,
      maceta_seleccionada_info: {
        Medidas: [],
        Moodboard: []
      },
      base_seleccionada: 0,
      base_seleccionada_info: null,
      caracteristica_abierta: 0,
      cart: [],
      wishlist: [],
      random: 0,
      show_description: true
    };
  },
  mounted() {
    console.log(this.random);
    this.random = this.getRandomInt(1, 2);

    //emitir evento para ocultarc menú
    this.$emit("updateMenu", 1);
    gtag('config', 'UA-163902944-1', {
      'page_title' : 'Producto: '+prod.NombreComun,
      'page_path': '/tienda/'+this.$route.params.producto
    });

  },
  created() {
    if (this.$session.has("cart")) {
      this.cart = this.$session.get("cart");
    }

    this.ciudad_seleccionada = this.$session.get('ciudad_seleccionada');

    //Codigo para llenar el wishlist
    if (this.$session.exists("user")) {
      if (this.$session.get("user") != undefined) {
        axios
          .get(
            "https://strapi.actstudio.xyz/users/" +
              this.$session.get("user").user.id,
            {
              headers: {
                Authorization: `Bearer ${this.$session.get("user").jwt}`
              }
            }
          )
          .then(response => {
            this.wishlist = response.data.productos;
          })
          .catch(error => {});
      }
    }

    // fetch(
    //   "https://strapi.actstudio.xyz/connect/facebook/callback",
    //   {}
    // ).then(res => console.log(res));

    axios
      .get(
        "https://strapi.actstudio.xyz/nombre-comuns?url=" +
          this.$route.params.producto
      )
      .then(response => {
        // console.log(response.data[0]);
        this.prod = response.data[0];
        this.items[2].text = this.prod.NombreComun;
        this.imagenes = this.prod.Galeria;
      });

    // console.log(this.$session.get("cart"));
  },
  computed: {
    add_cart_enabled: function() {
      return this.maceta_seleccionada == 0;
    }
    // showBase: function(){
    //   var baseNombre = '';

    //   for(var i = 0; i < this.maceta_seleccionada_info.Base.length; i++){
    //     baseNombre = this.maceta_seleccionada_info.Base.;
    //   }

    //   return baseNombre;
    // }
  },
  watch: {
    base_seleccionada: function() {
      if (this.base_seleccionada == 0) {
        this.base_seleccionada_info = null;
      }
    },
    tamano: function() {
      this.maceta_seleccionada = 0;
      this.base_seleccionada = 0;
      if (this.tamano == "c") {
        this.macetas = this.prod.Maceta.filter(
          maceta => maceta.Tamano == "Chico"
        );
      } else if (this.tamano == "m") {
        this.macetas = this.prod.Maceta.filter(
          maceta => maceta.Tamano == "Mediano"
        );
      } else if (this.tamano == "g") {
        this.macetas = this.prod.Maceta.filter(
          maceta => maceta.Tamano == "Grande"
        );
      } else {
        this.macetas = [];
      }

      this.imagenes = this.prod.Galeria;
      this.carousel = 0;
      this.refresh_carousel();
    },
    maceta_seleccionada: function() {
      this.base_seleccionada = 0;
    },
    $route(to, from) {
      
      axios
        .get(
          "https://strapi.actstudio.xyz/nombre-comuns?url=" +
            this.$route.params.producto
        )
        .then(response => {
          // console.log(response.data[0]);
          this.prod = response.data[0];
          this.items[2].text = this.prod.NombreComun;
          this.imagenes = this.prod.Galeria;
          this.refresh_carousel();

          this.tamano = 0;
          this.maceta_seleccionada = 0;
          this.maceta_over = 0;
          this.base_seleccionada = 0;
        });
    }
  },

  methods: {
    seleccionarMaceta: function(maceta){

      if(this.maceta_seleccionada != maceta.id){
        this.maceta_seleccionada = maceta.id; 
        this.maceta_seleccionada_info = maceta;
      }else{
        this.maceta_seleccionada = 0;
        this.maceta_seleccionada_info = {
          Medidas: [],
          Moodboard: []
        }
      }

    },
    agregarWishlist: function(id) {
      if (this.$session.has("user") && this.$session.get("user") != undefined) {
        var aux = this.wishlist.findIndex(element => element.id == id);

        var m = [];

        for (let n = 0; n < this.wishlist.length; n++) {
          m.push({ id: this.wishlist[n].id });
        }

        m.push({ id: id });

        console.log(aux);

        if (aux == -1) {
          axios
            .put(
              "https://strapi.actstudio.xyz/users/" +
                this.$session.get("user").user.id,
              {
                headers: {
                  Authorization: `Bearer ${this.$session.get("user").jwt}`
                },
                id: this.$session.get("user").jwt,
                productos: m
              }
            )
            .then(response => {
              this.wishlist = response.data.productos;
              console.log(response.data);
            });

          var aux2 = this;
          this.alertaWishlist = true;
          setTimeout(function() {
            aux2.alertaWishlist = false;
          }, 3000);
        } else {
          var aux2 = this;
          this.alertaWishlist = true;
          setTimeout(function() {
            aux2.alertaWishlist = false;
          }, 3000);
        }
      } else {
        var aux2 = this;
        this.alertaNoSesion = true;
        setTimeout(function() {
          aux2.alertaNoSesion = false;
        }, 3000);
      }
    },
    getRandomInt: function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    add_Cart: function() {
      var elemento = {
        producto: this.prod,
        cantidad: this.cantidad,
        size: this.tamano,
        maceta: null,
        base: null,
        precio: null
      };

      var item_aux = null;

      item_aux = this.cart.findIndex(
        item => item.producto.id == this.prod.id && item.size == this.tamano
      );

      if (this.maceta_seleccionada != 0) {
        elemento.maceta = this.maceta_seleccionada_info;
        elemento.precio = this.maceta_seleccionada_info.Precio;

        item_aux = this.cart.findIndex(
          item =>
            item.producto.id == this.prod.id &&
            item.size == this.tamano &&
            item.maceta != null &&
            item.maceta.id === this.maceta_seleccionada_info.id
        );
      }

      if (this.base_seleccionada != 0) {
        elemento.base = this.base_seleccionada_info;
        elemento.precio = this.base_seleccionada_info.Precio;

        item_aux = this.cart.findIndex(
          item =>
            item.producto.id == this.prod.id &&
            item.size == this.tamano &&
            item.base != null &&
            item.base.id === this.base_seleccionada_info.id
        );
      }

      // Si el producto no está en el carrito se agregan los campos tal cual.
      if (item_aux == -1) {
        this.cart.push(elemento);
      } else {
        this.cart[item_aux].cantidad += this.cantidad;
      }

      this.$session.set("cart", this.cart);

      // if (this.$session.has("cart")) {
      //   var auxiliar = this.$session.get("cart");

      //   var item_aux = null;

      //   item_aux = auxiliar.find(item => item.producto.id = this.prod.id);

      //   var count_aux = auxiliar.findIndex(item => item.producto.id = this.prod.id);

      //   alert(count_aux);

      //   if(count_aux){
      //     alert('entra');
      //     if(item_aux.base != null){

      //     }else if(item_aux.maceta != null){

      //     }else{

      //     }
      //   }else{
      //     alert('no entra');
      //   }
      //   console.log(count_aux);

      //   auxiliar.push(elemento);

      //   this.$session.set("cart", auxiliar);
      // } else {
      //   var carrito_auxiliar = [
      //     elemento
      //   ];

      //   this.$session.set("cart", carrito_auxiliar);
      // }

      this.$emit("updated");

      this.alertaCart = true;

      var aux = this;

      setTimeout(function() {
        aux.alertaCart = false;
      }, 3000);
    },
    add_Wishlist: function(id) {
      var aux = this.wishlist.findIndex(element => element.id == id);

      var m = [];

      for (let n = 0; n < this.wishlist.length; n++) {
        m.push({ id: this.wishlist[n].id });
      }

      m.push({ id: id });

      console.log(m);

      if (aux == -1) {
        axios
          .put(
            "https://strapi.actstudio.xyz/users/" +
              this.$session.get("user").user.id,
            {
              headers: {
                Authorization: `Bearer ${this.$session.get("user").jwt}`
              },
              id: this.$session.get("user").jwt,
              productos: m
            }
          )
          .then(response => {
            this.wishlist = response.data.productos;
            console.log(response.data);
          });
      }

      this.alertaWishlist = true;

      var aux = this;

      setTimeout(function() {
        aux.alertaWishlist = false;
      }, 3000);
    },
    login: function() {
      axios
        .post("http://192.168.15.100:1337/auth/local/", {
          identifier: "admin",
          password: "admin123"
        })
        .then(response => {
          // Handle success.
          console.log("Well done!");
          console.log("User profile", response.data.user);
          console.log("User token", response.data.jwt);
        })
        .catch(error => {
          // Handle error.
          console.log("An error occurred:", error);
        });
    },
    refresh_carousel: function() {
      var aux = this;
      this.show_carousel = false;
      setTimeout(() => {
        aux.show_carousel = true;
      }, 100);
    },
    borrar_carrito: function() {
      this.$session.clear();
    }
  }
};
</script>

